import React, { useState,useEffect } from "react";
import Header from '../../layout/header';
import Loader from "../../../Loader/Loader";
import DashboardMenu from "../../layout/dashboardMenu";
import axios from 'axios'
import ReactPaginate from 'react-paginate';
import BottomMenu from "../../layout/bottomMenu";
import NotFoundData from "../../../Images/no-data-found.webp";
import SuccessModal from "../../CustomModal/Success";
import FailedModal from "../../CustomModal/Failed";
const SitesCallingForm = ({
    saveReferralCallForm,
    referralCallForm=[],
    match
}) => {
    const [isLoading, setIsLoading] = useState(false)
    const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
    const [isFailedModalOpen, setIsFailedModalOpen] = useState(false);
    const [formValues, setFormValues] = useState({
        account_id:match.params.id,
        call_date:'',
        caller_poc_name:'',
        caller_poc_number:'',
        caller_poc_email:'',
        caller_poc_designation:'',
        receiver_poc_name:'',
        receiver_poc_number:'',
        receiver_poc_email:'',
        receiver_poc_designation:'',
    });

    useEffect(() => {
        let webView = localStorage.getItem('webview');
        if(webView !== undefined && webView == 'true') {
            const message = {
                event_name: 'screenshot_prevent',
                page_name: 'yes',
            }
            const nativeObject = window.ReactNativeWebView;
            if (nativeObject !== undefined) {
                setTimeout(function () {
                    nativeObject.postMessage(JSON.stringify(message));
                    window.addEventListener('message', () => {
                    })
                  }, 100);
            }
        }
    }, []);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormValues(prevState => ({
            ...prevState,
            [name]: value
        }));
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSuccessModalOpen(false)
        setIsFailedModalOpen(false)
        setIsLoading(true);
        
        const res=await saveReferralCallForm(formValues);

        if (res) {
            setIsSuccessModalOpen(true)
        }else{
            setIsFailedModalOpen(true)
        }
        setIsLoading(false);
    };

    useEffect(()=>{
        var now     = new Date(); 
        var year    = now.getFullYear();
        var month   = now.getMonth()+1; 
        var day     = now.getDate();
        var hour    = now.getHours();
        var minute  = now.getMinutes();
        var second  = now.getSeconds(); 
        if(month.toString().length == 1) {
             month = '0'+month;
        }
        if(day.toString().length == 1) {
             day = '0'+day;
        }   
        if(hour.toString().length == 1) {
             hour = '0'+hour;
        }
        if(minute.toString().length == 1) {
             minute = '0'+minute;
        }
        if(second.toString().length == 1) {
             second = '0'+second;
        }   
        var dateTime = year+'-'+month+'-'+day+' '+hour+':'+minute+':'+second;
        setFormValues(prevState => ({
            ...prevState,
            'call_date': dateTime
        }));
    },[])
    return (
        <>
            <SuccessModal
                isOpen={isSuccessModalOpen}
                msg={'Details saved successfully'}
                url={'referrals-sites-calling'}
            />
            <FailedModal
                isOpen={isFailedModalOpen}
                msg={'Something went wrong'}
                url={'referral-call-form'}
            />
            <Loader isLoading={isLoading}/>
            <div id="wrapper">
                <DashboardMenu/>
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <Header
                            title={'Calling Referral Form'}
                        />
                        <div className="container-fluid common-bg">
                            {/*Heading*/}
                            <div className="container-fluid bootstrap snippets bg-white">
                                <div className="bg-white p-4 rounded shadow-sm border">
                                    <h1 className="h4 mb-4 text-primary text-center">Fill the below Form</h1>
                                    <form onSubmit={handleSubmit}>
                                        <div className="row mb-3">
                                            <div className="col-md-6">
                                                <label htmlFor="call_date" className="form-label">
                                                    Call Date <span className="text-danger">*</span>
                                                </label>
                                                <input
                                                    type="datetime-local"
                                                    className="form-control"
                                                    id="call_date"
                                                    name="call_date"
                                                    onChange={handleInputChange}
                                                    required
                                                    disabled={true}
                                                    value={formValues.call_date}
                                                    min={new Date().toISOString().split('T')[0]+"T00:00"}
                                                />
                                            </div>

                                            <div className="col-md-6">
                                                <label htmlFor="caller_poc_name" className="form-label">Caller POC Name <span className="text-danger">*</span></label>
                                                <input
                                                    type="text"
                                                    id="caller_poc_name"
                                                    name="caller_poc_name"
                                                    className="form-control"
                                                    value={formValues.caller_poc_name}
                                                    onChange={handleInputChange}
                                                    placeholder="Enter caller POC name"
                                                    required
                                                />
                                            </div>

                                            <div className="col-md-6">
                                                <label htmlFor="caller_poc_number" className="form-label">Caller POC Number <span className="text-danger">*</span></label>
                                                <input
                                                    type="text"
                                                    id="caller_poc_number"
                                                    name="caller_poc_number"
                                                    className="form-control"
                                                    value={formValues.caller_poc_number}
                                                    onChange={handleInputChange}
                                                    placeholder="Enter caller POC number"
                                                    pattern="\d{10}"
                                                    maxLength="10"
                                                    title="Please enter exactly 10 digits"
                                                    required
                                                />
                                            </div>

                                            <div className="col-md-6">
                                                <label htmlFor="caller_poc_email" className="form-label">Caller POC Email</label>
                                                <input
                                                    type="email"
                                                    id="caller_poc_email"
                                                    name="caller_poc_email"
                                                    className="form-control"
                                                    value={formValues.caller_poc_email}
                                                    onChange={handleInputChange}
                                                    placeholder="Enter caller POC email"
                                                    pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$"
                                                    title="Please enter a valid email address"
                                                    // required
                                                />
                                            </div>

                                            <div className="col-md-6">
                                                <label htmlFor="caller_poc_designation" className="form-label">Caller POC Designation <span className="text-danger">*</span></label>
                                                <input
                                                    type="text"
                                                    id="caller_poc_designation"
                                                    name="caller_poc_designation"
                                                    className="form-control"
                                                    value={formValues.caller_poc_designation}
                                                    onChange={handleInputChange}
                                                    placeholder="Enter caller POC designation"
                                                    required
                                                />
                                            </div>

                                            <div className="col-md-6">
                                                <label htmlFor="receiver_poc_name" className="form-label">Receiver POC Name <span className="text-danger">*</span></label>
                                                <input
                                                    type="text"
                                                    id="receiver_poc_name"
                                                    name="receiver_poc_name"
                                                    className="form-control"
                                                    value={formValues.receiver_poc_name}
                                                    onChange={handleInputChange}
                                                    placeholder="Enter receiver POC name"
                                                    required
                                                />
                                            </div>

                                            <div className="col-md-6">
                                                <label htmlFor="receiver_poc_number" className="form-label">Receiver POC Number <span className="text-danger">*</span></label>
                                                <input
                                                    type="text"
                                                    id="receiver_poc_number"
                                                    name="receiver_poc_number"
                                                    className="form-control"
                                                    value={formValues.receiver_poc_number}
                                                    onChange={handleInputChange}
                                                    placeholder="Enter receiver POC number"
                                                    pattern="\d{10}"
                                                    maxLength="10"
                                                    title="Please enter exactly 10 digits"
                                                    required
                                                />
                                            </div>

                                            <div className="col-md-6">
                                                <label htmlFor="receiver_poc_email" className="form-label">Receiver POC Email</label>
                                                <input
                                                    type="email"
                                                    id="receiver_poc_email"
                                                    name="receiver_poc_email"
                                                    className="form-control"
                                                    value={formValues.receiver_poc_email}
                                                    onChange={handleInputChange}
                                                    placeholder="Enter receiver POC email"
                                                    pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$"
                                                    title="Please enter a valid email address"
                                                    // required
                                                />
                                            </div>

                                            <div className="col-md-6">
                                                <label htmlFor="receiver_poc_designation" className="form-label">Receiver POC Designation <span className="text-danger">*</span></label>
                                                <input
                                                    type="text"
                                                    id="receiver_poc_designation"
                                                    name="receiver_poc_designation"
                                                    className="form-control"
                                                    value={formValues.receiver_poc_designation}
                                                    onChange={handleInputChange}
                                                    placeholder="Enter receiver POC designation"
                                                    required
                                                />
                                            </div>
                                        </div>

                                        <div className="d-flex justify-content-center">
                                            <button type="submit" className="btn btn-primary btn-lg w-40">
                                                Submit
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </>
      );
};

export default SitesCallingForm;